import type { MouseEvent, ReactNode } from "react";

export function LabLink({
  href,
  className,
  children,
  onTraverse,
}: {
  href: string;
  className?: string;
  children: ReactNode;
  onTraverse?: (href: string, event: MouseEvent<HTMLAnchorElement>) => void;
}) {
  return (
    <a
      className={className}
      href={href}
      onClick={(event) => {
        if (!onTraverse) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        onTraverse(href, event);
      }}
    >
      {children}
    </a>
  );
}
